var React = require('react');

function IcoPause (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"iwh","d":"M46.5,0.4C20.9,0.4,0,21.2,0,46.9c0,25.6,20.9,46.5,46.5,46.5S93,72.5,93,46.9\n      C93,21.2,72.1,0.4,46.5,0.4z M46.5,6.6c22.3,0,40.3,18,40.3,40.3s-18,40.3-40.3,40.3S6.2,69.1,6.2,46.9S24.2,6.6,46.5,6.6z","key":0}),React.createElement("path",{"className":"iwh","d":"m44.051847,34.650001l-5.9,0c-0.5,0 -1,0.4 -1,1l0,22.7c0,0.5 0.4,1 1,1l5.8,0c0.5,0 1,-0.4 1,-1l0,-22.8c0,-0.5 -0.4,-0.9 -0.9,-0.9z","key":1}),React.createElement("path",{"className":"iwh","d":"m54.848155,34.650001l-5.8,0c-0.5,0 -1,0.4 -1,1l0,22.7c0,0.5 0.4,1 1,1l5.8,0c0.5,0 1,-0.4 1,-1l0,-22.8c-0.1,-0.5 -0.5,-0.9 -1,-0.9z","key":2})]);
}

IcoPause.defaultProps = {"viewBox":"0 0 93 94","id":"pauseic","width":"93px","height":"94px"};

module.exports = IcoPause;

IcoPause.default = IcoPause;
